export const RECOGNITION_STATUS = {
    REJECTED: 'rejected',
    CANCELLED: 'cancelled',
    APPROVED: 'approved',
};
